import React, { useState, useEffect } from "react";
import { CircularProgress } from "@material-ui/core";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import MailOutlineRoundedIcon from "@material-ui/icons/MailOutlineRounded";
import StarRoundedIcon from "@material-ui/icons/StarRounded";
import "react-vertical-timeline-component/style.min.css";
import "./milestoneComp.css";

function MilestoneComp(props) {
  const [milestoneData, setMilestoneData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setMilestoneData(props.milestoneData.data);
    setLoading(props.milestoneData.loading);
  }, [props]);

  if (loading) {
    return (
      <div className="loadingClass">
        <CircularProgress size="1.5rem" />
      </div>
    );
  }

  return (
    <div className="shipmentDetailsComp">
      <div className="timelineParent">
        <VerticalTimeline layout="1-column-left">
          {milestoneData.map((element) => {
            let date = Object.values(element.VisibleNote).map((element) => {
              return element;
            });
            return (
              <VerticalTimelineElement
                className="vertical-timeline-element--work"
                date={date ? date : "& nbsp;"}
                iconStyle={{}}
                icon={
                  <div
                    style={{
                      border: `2px solid ${element.ColorHexa}`,
                      borderRadius: "50%",
                    }}
                  >
                    <img
                      className="milestone-img"
                      src={element.IconPath}
                      alt={element.IconName}
                    />
                  </div>
                }
              >
                <p className="vertical-timeline-element-title">
                  {element.Description}
                </p>
              </VerticalTimelineElement>
            );
          })}
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default MilestoneComp;
